module.exports = __webpack_public_path__ + "static/media/icon3-active.7e089406.svg";